"use client"

import { useLocation } from "@tanstack/react-router"
import { HiArrowLeft } from "react-icons/hi2"

const variants = {
  normal: "p-m",
  overlay: "fixed top-m left-m z-50 bg-black/40 backdrop-blur-sm rounded-xl p-s text-white",
}

interface Props {
  variant?: keyof typeof variants
}

export function BackButton({ variant = "normal" }: Props) {
  const pathname = useLocation({
    select: (location) => location.pathname,
  })
  const isInnerPage = pathname !== "/" && pathname !== "/home"

  if (!isInnerPage) return <div className="size-m" />

  return (
    <button onClick={() => history.back()} className={variants[variant]}>
      <HiArrowLeft />
    </button>
  )
}
